import { Profissionais } from '../models/profissionais.model';
import { AuthenticateService } from './authenticate.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URL_CIDADAO_REGISTROS } from '../../src/util/constants';

@Injectable({
  providedIn: 'root'
})
export class ProfissionalService {

  constructor(private http: HttpClient, private auth: AuthenticateService) {

  }

  async recuperar() {
    return this.http.get(`${URL_CIDADAO_REGISTROS}rest/meuprofissional`,
    {headers :this.getHeadersToken()}).toPromise().then((result:any) => {
      return result.map(data => new Profissionais(data));
    }).catch((error) => {
      return [];
    });
  }

  async recuperarTodosPorCrm(crm, orgao, uf) {
    return this.http.get(`${URL_CIDADAO_REGISTROS}rest/profissional?documento=${crm}&orgao=${orgao}&uf=${uf}`,
    {headers :this.getHeadersToken()}).toPromise().then((result:any) => {
      if(result.length > 1) {
        return result.map(data => new Profissionais(data));
      } else {
        return result;
      }
    }).catch((error) => {
      return [];
    });
  }

  async recuperarTodosPorCnsCpf(documento) {
    return this.http.get(`${URL_CIDADAO_REGISTROS}rest/profissional?documento=${documento}`,
    {headers :this.getHeadersToken()}).toPromise().then((result:any) => {
       return result;
    }).catch((error) => {
      return [];
    });
  }

  async excluir(prof) {
    return this.http.delete(`${URL_CIDADAO_REGISTROS}rest/meuprofissional/${prof.id}`,
    {headers :this.getHeadersToken()}).toPromise().then((result:any) => {
      return true;
    }).catch((error) => {
      return false;
    });
  }

  async adicionar(prof) {
    return this.http.post(`${URL_CIDADAO_REGISTROS}rest/meuprofissional`,prof,
    {headers :this.getHeadersToken()}).toPromise().then((result:any) => {
      return result;
    }).catch((error) => {
      return error;
    });
  }

  getHeaders() {
    return {
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: this.auth.getAuthorizationToken()
    };
  }

  getHeadersToken() {
    return {
      Authorization: this.auth.getAuthorizationToken(),
      'Content-Type': 'application/json'
    };
  }


  getHeadersJson() {
    return {
      'Content-Type': 'application/json'
    };
  }

}
